<template>
  <div class="conflicts">
    <div class="error">
      <span><font-awesome-icon :icon="['fas', 'exclamation-triangle']" /></span>
      {{ _.overlap_participations_detected }}
    </div>
    <div class="item" v-if="sessions.length > 0" v-html="getPresentation()"></div>
    <table>
      <tbody v-for="(sval, skey) in sessions" :key="skey">
        <tr>
          <td></td>
          <td :style="{ color: getColor(sval), background: getBackground(sval) }">
            {{ formatDate(sval.day) }}, {{ sval.start_time }} - {{ sval.end_time }}
          </td>
          <td :style="{ color: getColor(sval), background: getBackground(sval), 'text-align': 'right' }">
            {{ sval.room.name }}
          </td>
        </tr>
        <tr v-if="sval.session_type">
          <td></td>
          <td :style="{ color: getColor(sval), background: getBackground(sval) }" colspan="2">
            {{ sval.session_type.name }}
          </td>
        </tr>
        <tr class="title session">
          <td></td>
          <td :style="{ color: getColor(sval), background: getBackground(sval) }" colspan="2">
            <router-link v-if="['admin','user', 'secretariat'].includes(user.role_id) || !sval.private" :to="'/session/' + sval.id + '/persons'">
              <b v-html="(sval.code || '') + ' ' + sval.title"></b>
            </router-link>
            <span v-else>
              <b v-html="(sval.code || '') + ' ' + sval.title"></b>
            </span>
          </td>
        </tr>
        <tr v-if="sval.persons.length > 0" class="person">
          <td>
            <div class="time">{{ sval.start_time }} &ndash; {{ sval.end_time }}</div>
          </td>
          <td :style="{ color: getColor(sval), background: getBackground(sval) }" colspan="2">
            <div class="person">
              {{ sval.persons[0].role.name }}: <b>{{ formatPerson(sval.persons[0].person, 'person') }}</b>
            </div>
          </td>
        </tr>
        <tr v-if="sval.presentations.length > 0" class="title presentation" :class="{ blocked: !['admin','user', 'secretariat'].includes(user.role_id) && sval.private }">
          <td></td>
          <td colspan="2">
            <span v-if="sval.presentations[0].start_time && sval.presentations[0].end_time">{{ sval.presentations[0].start_time }} &ndash; {{ sval.presentations[0].end_time }}</span>
            <span v-else>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
          </td>
        </tr>
        <tr v-if="sval.presentations.length > 0" class="title presentation" :class="{ blocked: !['admin','user', 'secretariat'].includes(user.role_id) && sval.private }">
          <td></td>
          <td colspan="2">
            <router-link v-if="['admin','user', 'secretariat'].includes(user.role_id) || !sval.private" :to="'/presentation/' + sval.presentations[0].presentation.id + '/persons'">
              <b v-html="(sval.presentations[0].code || '') + ' ' + sval.presentations[0].presentation.title"></b>
            </router-link>
            <span v-else>
              <b v-html="(sval.presentations[0].code || '') + ' ' + sval.presentations[0].presentation.title"></b>
            </span>
          </td>
        </tr>
        <tr v-if="sval.presentations.length > 0">
          <td>
            <div class="time" v-if="settings.app.participation_overlap_presentation_times === 'presentation'">
              <span v-if="sval.presentations[0].start_time && sval.presentations[0].end_time">{{ sval.presentations[0].start_time }} &ndash; {{ sval.presentations[0].end_time }}</span>
              <span v-else>{{ sval.start_time }} &ndash; {{ sval.end_time }}</span>
            </div>
            <div class="time" v-if="settings.app.participation_overlap_presentation_times === 'session'">
              {{ sval.start_time }} &ndash; {{ sval.end_time }}
            </div>
          </td>
          <td colspan="2">
            <div class="person">
              {{ sval.presentations[0].presentation.persons[0].role.name }}: <b>{{ formatPerson(sval.presentations[0].presentation.persons[0].person, 'person') }}</b>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { API_URL } from '@/config'
export default {
  props: ['id'],
  data() {
    return {
      presentation: {},
      sessions: [],
    }
  },
  methods: {
    getColor(session) {
      return ['admin','user', 'secretariat'].includes(this.user.role_id) || !session.private
        ? (session.session_type) ? session.session_type.value.color : '#000000'
        : '#acacac'
    },
    getBackground(session) {
      return ['admin','user', 'secretariat'].includes(this.user.role_id) || !session.private
        ? (session.session_type) ? session.session_type.value.background : '#ececec'
        : '#ececec'
    },
    getPresentation() {
      return '<b>' + this.presentation.code + ' ' + this.presentation.title + '</b>';
    },
  },
  async created() {
    const [presentation, sessions] = await Promise.all([
      this.axios.get(API_URL + '/presentations/' + this.id),
      this.axios.get(API_URL + '/presentations/' + this.id + '/overlaps')
    ]);
    this.presentation = presentation.data;
    this.sessions = sessions.data;
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
@import '@/assets/scss/conflicts';
</style>